<template>
    <div v-if="editable"  class="uk-flex uk-width-1-1">
        <form-sourced-autosuggest
            entity="firm"
            :id="id"
            :selection="value"
            :external-search="externalSearch"
            name="firm_id"
            :error="error"
            :required="false"
            :placeholder="placeholder"
            :can-add="canAdd"
            :add-handler="create_firm"
            width="1-1"
            class="uk-width-1-1"
            @pick="firm_picked"
            @unpick="firm_cleared"
        />
        <div v-if="!!value" class="uk-margin-small-left uk-flex-item-none">
            <router-link :to="{name: 'firm.edit', params: {id: value}}" class="uk-button" title="View firm info" target="_blank">
                <open-icon glyph="external-link" />
            </router-link>
        </div>
    </div>
    <router-link v-else-if="!!value" :to="{name: 'firm.edit', params: {id: value}}" class="uk-form-controls-text uk-display-inline-block" target="_blank">{{ firm.name }}</router-link>
    <span v-else class="uk-text-muted">(No firm)</span>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex"

import FormSourcedAutosuggest from "./FormSourcedAutosuggest"
import OpenIcon from "./OpenIcon"

export default {
    components: {
        FormSourcedAutosuggest,
        OpenIcon
    },
    methods: {
        firm_picked (firm, field = "firm_id", created = false) {
            if(firm && firm.id) this.$emit("pick", firm, field, created)
        },
        firm_cleared () {
            this.$emit("pick", { id: 0, name: "" })
        },
        create_firm ({ entity, context, data }) {
            this.$store.dispatch("CREATE_RECORD", {
                entity: "firm",
                data: { name: data.name, firm_type: this.firmType }
            }).then(firm => {
                this.$nextTick(() => {
                    this.firm_picked(firm, "firm_id", true)
                })
            })
        }
    },
    computed: {
        ...mapGetters(["entity_records"]),
        raw_firm_records () {
            return this.entity_records("firm")
        },
        firm () {
            if(!this.value) return null
            return this.raw_firm_records.find(firm => firm.id === this.value)
        }
    },
    props: {
        id: {
            type: String,
            default: "firm_id"
        },
        value: {
            type: Number,
            required: true
        },
        firmType: {
            type: String,
            default: ""
        },
        placeholder: {
            type: String,
            default: ""
        },
        error: {
            type: String,
            default: ""
        },
        editable: {
            type: Boolean,
            default: true
        },
        canAdd: {
            type: Boolean,
            default: true
        },
        externalSearch: {
            type: String,
            default: ""
        }
    },
    data () {
        return {
            firms: []
        }
    }
}
</script>
